<template>
  <div class="signIn-container" :style="{'padding-top': showTopTit ? '0.46rem' : '0'}">
      <Bag ref="bag" :bagInf="bagInf" @passGiftCode="passGiftCode"></Bag>
      <Model @shareWeb="shareWeb" v-show="maskType" @downloadGame="clickBtn" @closeModel="closeModel" :maskType="maskType" ref="Model"></Model>
      <div class="status-bar" :style="{'top': showTopTit ? '0.46rem' : '0'}">活动结束时间：{{endTime}} <span @click="openRule">规则<label></label></span></div>
      <div class="banner">
        <img :src="entryObj.activityClient.topImage" alt="">
        <div @click="clickBtn" class="banner-btn" :style="{'background-image':'url('+btnRed+')'}">
            <span>{{btnTxt}}</span>
        </div>
      </div>
      <div class="award-module" :style="{'background-image':'url('+bgStone2+')'}">
        <img class="bg-title" src="~/assets/signInModule/title-award.png" alt="">
        <div class="borderShadow">
            <div class="award-frame">
                <div v-for="item in awardDisplayList" :key="item.propId" class="award-row" :style="{'background-image':'url('+bgAward+')'}">
                    <img alt="" :src="item.icon" />
                    <div class="award-name ellipsis">{{item.propName}}</div>
                </div>
            </div>
        </div>
      </div>
      <div class="share-award-module" :style="{'background-image':'url('+bgStone3+')'}">
        <img class="bg-title" src="~/assets/signInModule/title-share.png" alt="">
        <div class="borderShadow">
            <div class="share-frame">
                <div class="title-tip">在签到规定天数后分享即可获得分享奖励</div>
                <div class="award-column">
                    <div v-for="item in shareAwardList.slice(0,2)" :key="item.checkinShareId" class="award-row" :style="{'background-image':'url('+bgAwardShadow+')'}">
                        <img class="award-row-img" alt="" :src="item.icon" />
                        <div class="award-name ellipsis">{{item.awardName}}</div>
                        <div class="bg-award-text" :style="{'background-image':'url('+bgAwardText+')'}">
                            签到第<span>{{item.checkinDay}}</span>天
                        </div>
                        <div class="share-award-mask" v-if="item.awardStatus">
                            <img class="icon-geted" src="~/assets/signInModule/icon-geted.png" alt="">
                        </div>
                    </div>
                </div>
                <div class="award-column">
                    <div class="award-row" v-for="item in shareAwardList.slice(2,5)" :key="item.checkinShareId" :style="{'background-image':'url('+bgAwardShadow+')'}">
                        <img class="award-row-img" alt="" :src="item.icon" />
                        <div class="award-name ellipsis">{{item.awardName}}</div>
                        <div class="bg-award-text" :style="{'background-image':'url('+bgAwardText+')'}">
                            签到第<span>{{item.checkinDay}}</span>天
                        </div>
                        <div class="share-award-mask" v-if="item.awardStatus">
                            <img class="icon-geted" src="~/assets/signInModule/icon-geted.png" alt="">
                        </div>
                    </div>
                </div>
                <div @click="getShareAward" class="btn" :style="{'background-image':'url('+btnGreen+')'}">
                    <span>点击领取</span>
                </div>
            </div>
        </div>
      </div>
      <div class="signIn-module" :style="{'background-image':'url('+bgStone4+')'}">
            <img class="bg-title" src="~/assets/signInModule/title-signIn.png" alt="">
            <div class="borderShadow">
                <div class="signIn-frame">
                    <div style="display:flex">
                        <div @click="clickBtn" class="btn" :style="{'background-image':'url('+btnYellow+')'}">
                            <span style="font-weight:bolder;">{{btnTxt}}</span>
                        </div>
                        <div v-if="checkInDailyState" class="btn" :style="{'background-image':'url('+btnGreenGray+')'}">
                            <span style="color:#4F5742">已签到</span>
                        </div>
                        <div v-else @click="clicksign" class="btn" :style="{'background-image':'url('+btnGreen+')'}">
                            <span>点击签到</span>
                        </div>
                    </div>
                    <div class="signIn-info">
                        已有"<b>{{joinNum}}</b>"人参加
                        <span>累计签到"<b>{{checkInDays}}</b>"次</span>
                    </div>
                    <div class="signIn-list">
                        <div class="signIn-row" :style="{'background-image':'url('+bgSignIn+')'}"  v-for="item in checkInAward" :key="item.awardId">
                            <div class="signIn-award-title">第<span>{{item.awardDays}}</span>天</div>
                            <img class="signIn-row-img" :src="item.icon" alt=""/>
                            <div class="signIn-award-name ellipsis">{{item.awardName}}</div>
                            <div class="award-mask" v-if="checkInDays >= item.awardDays">
                                <img class="icon-geted" src="~/assets/signInModule/icon-geted.png" alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
      </div>
      <div class="share-module" :style="{'background-image':'url('+bgStone5+')'}">
        <div @click="shareWeb(0x1)" class="share-row" :style="{'background-image':'url('+bgShareIcon+')'}">
            <img src="~/assets/signInModule/icon-wechat.png" />
            <div class="share-row-name">微信</div>
        </div>
        <div @click="shareWeb(0x2)" class="share-row" :style="{'background-image':'url('+bgShareIcon+')'}">
            <img src="~/assets/signInModule/icon-circle.png" />
            <div class="share-row-name">朋友圈</div>
        </div>
        <div @click="shareWeb(0x3)" class="share-row" :style="{'background-image':'url('+bgShareIcon+')'}">
            <img src="~/assets/signInModule/icon-qq.png" />
            <div class="share-row-name">QQ</div>
        </div>
        <div @click="shareWeb(0x4)" class="share-row" :style="{'background-image':'url('+bgShareIcon+')'}">
            <img src="~/assets/signInModule/icon-zone.png" />
            <div class="share-row-name">QQ空间</div>
        </div>
      </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapState } from "vuex";
import moment from "moment";
import config from "@/../config";
import { openApp } from "@/utils/utils";
import qs from 'qs';
import active from '@/utils/axios/index';
import primaryApi from "@/utils/primaryApi";
import bgStone2 from '@/assets/signInModule/bg-stone-2.png'
import bgStone3 from '@/assets/signInModule/bg-stone-3.png'
import bgStone4 from '@/assets/signInModule/bg-stone-4.png'
import bgStone5 from '@/assets/signInModule/bg-stone-5.png'
import bgAward from '@/assets/signInModule/bg-award.png'
import bgAwardShadow from '@/assets/signInModule/bg-award-shadow.png'
import bgAwardText from '@/assets/signInModule/bg-award-text.png'
import btnGreen from '@/assets/signInModule/btn-green.png'
import btnYellow from '@/assets/signInModule/btn-yellow.png'
import btnGreenGray from '@/assets/signInModule/btn-green-gray.png'
import bgSignIn from '@/assets/signInModule/bg-signIn.png'
import bgShareIcon from '@/assets/signInModule/bg-share-icon.png'
import btnRed from '@/assets/signInModule/btn-red.png'
import Model from "@/components/signInModule/Model.vue"; // 背包
import Bag from "@/components/currency/bag"; // 背包
import { Toast,Dialog } from 'vant';
Vue.use(Toast,Dialog);
export default {
    props:['entryObj'],
    components: {
        Bag,
        Model
    },
    computed: {
    ...mapState([
      "uuid",
      "activityId",
      "propList",
      "cashcount",
      "goldcount",
      "activeBagMap",
      "firstentry",
      "freeact",
      "guide",
      "userName"
    ]),
  },
  data() {
    return {
        bgAward,
        bgStone2,
        bgStone3,
        bgStone4,
        bgStone5,
        bgAward,
        btnGreen,
        btnYellow,
        btnGreenGray,
        bgAwardShadow,
        bgAwardText,
        bgSignIn,
        bgShareIcon,
        btnRed, // 静态图片资源
        gameInf: {}, // 游戏信息
        gameId:'', // 游戏ID
        isDownload: false, // 是否处于下载游戏过程
        maskType: false,
        progress: 0, // 下载进度
        endTime:'',
        joinNum:0,
        bagInf: {
            src: require ("@/assets/signInModule/bag.png"), // 背包图片src，相对当前文件的路径
            bagStyle: "width: 0.58rem;height: 0.58rem", // 背包图片样式
            bottmTit: false,
            bagBoxSyle: "background: none;width: 0.58rem;height: 0.58rem"
        },
        shareData: {}, // 分享模块信息
        btnTxt:'下载游戏',
        globalStates:{},
        checkInAward:[],
        shareUrlArr:[],
        awardDisplayList:[], // 大奖展示奖品列表
        shareAwardList:[], // 分享奖品列表
        shareModuleId:'',
        checkInDays:0, // 当前签到天数
        checkInLimit:31,
        checkinShareModuleId:'', // 分享奖励moduleId
        checkInId:'', // 签到模块id
        awardInfo:{}, // 领取的奖励信息
        checkInDailyState:'', // 签到状态
        mastStatus: false,
        showTopTit: false
    }
  },
  watch: {
    maskType(value){
      if(value){
        this.$refs.Model.rule = this.entryObj.description
        this.$refs.Model.awardInfo = this.awardInfo
      }else{
          this.mastStatus = false
      }
    },
    btnTxt(value){
        this.$refs.Model.btnTxt = value
    }
  },
  created () {
        /* 233乐园内/外部下载进度的回调 */
        window.DownloadProgress = this.downloadProgress
        window.DownloadFailed = this.downloadFailed
        window.DownloadInterrupt = this.downloadInterrupt
        window.DownloadSuccess = this.downloadSuccess
        /* 状态管理 */
        if (this.$route.query.f) {
            // 通过链接中是否存在分享id，判断是否通过分享进入
            this.globalStates = {
                shareParams: {
                    locationId: parseInt(this.$route.query.f), // 分享功能ID
                    relationship: parseInt(this.$route.query.g), // 分享关系
                    relationshipParams: parseInt(this.$route.query.c), // 分享关系参数
                    parentUUID: this.$route.query.u, // 分享人的UUID
					scheme: "",
					parentName: this.$route.query.n || "none", // 分享人的用户名
					isHelp: this.$route.query.h || 0 // 分享行为是否为请求好友助力 1是0否
                },
            };
        } else {
            // 非分享进入，分享中转信息写死
            this.globalStates = {
                shareParams: {
                    locationId: this.activityId, // 分享功能ID
                    relationship: 5, // 分享关系
                    relationshipParams: this.activityId, // 分享关系参数
                    parentUUID: "none", // 分享人的UUID
					scheme: "",
					parentName: "none", // 分享人的用户名
					isHelp: 0 // 分享行为是否为请求好友助力 1是0否
                },
            };
        }
        if (primaryApi && primaryApi.isSource == "pd") {
            // 判断是否乐园
            // 乐园显示顶部导航栏
            this.showTopTit = true;
        }
  },
  mounted () {
    this.$tea("event_active_show", {activityId: this.activityId, open_in_233: primaryApi.isSource ? "yes" : "no"}); // 数据埋点
    this.endTime = new moment(this.entryObj.activityServer.endTime).format('YYYY-MM-DD')
    const contentShow = this.entryObj.contentShow
    this.activityStatus = this.entryObj.activityServer.activityStatus
    this.sendVotePoint()
    this.getAnalysePoint()
    for(var i = 0; i<contentShow.length; i++){
        if(contentShow[i].indexOf('missionAndRanking') > -1){
            this.checkInId = contentShow[i].split("_")[1]
            this.getbuttonlist(contentShow[i].split("_")[1])
        }
        if(contentShow[i].indexOf('game') > -1){
            this.getGame(contentShow[i].split("_")[1])
        }
        if(contentShow[i].indexOf('share') > -1){
            this.$tea("event_new_share_landing_open", {
              locationId: 202,
              relationship: 4,
              relationshipExtra2: this.activityId,
              parentUUID: this.globalStates.shareParams.parentUUID,
              landingParam: this.activityId
            });
            this.shareModuleId = contentShow[i].split("_")[1]
            this.shareInfo();
            this.getShareCsvByLocationId();
        }
        if(contentShow[i].indexOf('awardDisplay') > -1){
            this.getAwardDisplayList(contentShow[i].split("_")[1])
        }
        if(contentShow[i].indexOf('checkinShare') > -1){
            this.checkinShareModuleId = contentShow[i].split("_")[1]
            this.getCheckinShareMissionList()
        }
    }
  },
  methods: {
    openRule(){
        this.$tea('event_activemodal_taprule', { 'activityId': this.activityId}); //规则按钮点击
        this.maskType = 'rule'
    },
    sendVotePoint(event){
        active.getAnalysePoint(config.API_HOST + "/apiserv/api/activity/analyse/point", {
            activityId: this.activityId,
            eventName:'event_signIn_active_show',
            uuid:this.uuid
        }).then(({data}) => {

        })
    },
    getAnalysePoint(){
        active.getAnalysePoint(config.API_HOST + "/apiserv/api/activity/analyse/pointCount", {
            activityId: this.activityId,
            eventNameList:'event_signIn_active_show',
            uuid:this.uuid,
            endTime:new Date(new Date().toLocaleDateString()).getTime()
        }).then(({data}) => {
            this.joinNum = data.event_signIn_active_show
        }).catch((error) => {
            this.$toast("网络不稳定，请稍后");
        });
    },
    // 判断运行环境是否233
    correctTerminal() {
        if (primaryApi.isSource == "pd" || primaryApi.isSource == "sg") {
            return true;
        } else {
            Dialog.confirm({
                title: '打开233乐园 赢取好礼',
                message: '参加活动，赢取游戏好礼，233乐园【活动专区】更多游戏礼物等你来领取',
            }).then(() => {
                const activeObj = {
                    activityId:this.activityId,
                    relationship:4,
                    guide:this.guide
                } // 活动相关数据
                openApp(activeObj,this.globalStates,'main')
            }).catch(() =>{})
            return false;
        }
    },
    passGiftCode(giftCodeNum) {
        this.awardInfo.giftCodeNum = giftCodeNum;
        this.maskType = this.mastStatus
    },
    closeModel(){
        this.maskType = false
    },
    // 领取分享奖励
    getShareAward(){
        if (!this.correctTerminal()) { // 判断运行环境是否是233
            return false;
        }
        if(!primaryApi.isGameInstall(this.gameInf.detail.packageName)){
            this.maskType = 'fail'
            return
        }
        let theAward = {}
        for(let i = 0;i< this.shareAwardList.length; i++){
            if(!this.shareAwardList[i].awardStatus || this.shareAwardList[i].awardStatus == 0){
                theAward = this.shareAwardList[i]
                break
            }
        }
        if(theAward.checkinDay > this.checkInDays){
            this.$toast('签到天数未满足领取条件')
            return
        }
        if(theAward.checkinShareDay < theAward.checkinDay || !theAward.checkinShareDay){
            this.$toast('分享活动后才能领取奖励哦')
            return
        }
        active.getShareAward(config.API_HOST +'/apiserv/api/activity/checkinShare/missionAward', qs.stringify({
            uuid:this.uuid,
            checkinShareId:theAward.checkinShareId,
            activityId: this.activityId
        })).then((res) => {
            if(res.code  == 200 || res.return_code == 200){
                this.$tea('event_activemodal_checkin_share_reward', { 'activityId': this.activityId, 'missionstatus':1,'errormsg':''});//数据埋点
                this.awardInfo = res.data.awardList[0]
                theAward.awardStatus = true
                if( this.awardInfo.propType == 20){
                    this.mastStatus = 'shareSuccess'
                    this.$refs.bag.obtainCode(this.awardInfo.propId);
                }else{
                    this.maskType = 'shareSuccess'
                }
            }else{
                this.$tea('event_activemodal_checkin_share_reward', { 'activityId': this.activityId, 'missionstatus':0,'errormsg':res.message || res.return_msg});//数据埋点
                this.$toast(res.message || res.return_msg)
            }
        })
    },
    // 获取签到奖品列表
    getbuttonlist(){
        active.checkinList(config.API_HOST +'/apiserv/api/activity/checkinShare/checkinList', {
            uuid: this.uuid,
            moduleId:this.checkInId,
            activityId: this.activityId
        }).then((res) => {
            if(res.return_code == 200 || res.code == 200){
                this.checkInAward = res.data.checkinResponseList;
                this.checkInDays = res.data.checkinDay || 0;
                this.checkInDailyState = res.data.checkinDailyStatus;
            }else{
                this.$toast(res.return_msg || res.message)
            }
        })
    },
    //点击签到
    clicksign(){
        if (!this.correctTerminal()) { // 判断运行环境是否是233
            return false;
        }
        if(!primaryApi.isGameInstall(this.gameInf.detail.packageName)){
            this.maskType = 'fail'
            return
        }
        if(this.lock()){
            if(this.checkInDailyState == 1){
                this.$tosat('今日已签到，请明日再来');
                this.$tea('event_activemodal_checkin', { 'activityId': this.activityId, 'checkin_days':this.checkInDays,'checkin_daily_state':2});//数据埋点
                return
            }
            this.$tea('event_activemodal_checkin', { 'activityId': this.activityId, 'checkin_days':this.checkInDays,'checkin_daily_state':1});//数据埋点
            active.checkinAndAward(config.API_HOST +'/apiserv/api/activity/checkinShare/checkinAndAward', qs.stringify({
                uuid: this.uuid,
                moduleId: this.checkInId,
                activityId: this.activityId
            })).then((res) => {
                if(res.code  == 200 || res.return_code == 200){
                    this.awardInfo = res.data.awardList[0]
                    this.checkInDays += 1
                    if( this.awardInfo.propType == 20){
                        this.mastStatus = 'signInSuccess'
                        this.$refs.bag.obtainCode(this.awardInfo.propId,'signInSuccess');
                    }else{
                        this.maskType = 'signInSuccess'
                    }
                }else{
                    this.$tea('event_activemodal_checkin', { 'activityId': this.activityId, 'checkin_days':this.checkInDays,'checkin_daily_state':-1});//数据埋点
                    this.$toast(res.message || res.return_msg)
                }
            })
        }
    },
    // 获取分享奖励列表
    getCheckinShareMissionList(){
        active.getCheckinShareMissionList(config.API_HOST +'/apiserv/api/activity/checkinShare/missionList', {
            uuid:this.uuid,
            moduleId:this.checkinShareModuleId,
            activityId: this.activityId
        }).then((res) => {
            if(res.return_code == 200 || res.code == 200){
                this.shareAwardList = res.data
            }else{
                this.$toast(res.return_msg || res.message)
            }
        })
    },
    // 设置当前分享天数
    setShareCheckInDay(){
        active.setShareCheckInDay(config.API_HOST +'/apiserv/api/activity/checkinShare/shareCheckinDay', qs.stringify({
            uuid: this.uuid,
            activityId: this.activityId,
            checkinDay: this.checkInDays
        })).then((res) => {
            this.getCheckinShareMissionList()
        })
    },
    // 获取大奖展示列表
    getAwardDisplayList(moduleId){
        active.getAwardDisplayList(config.API_HOST +'/apiserv/api/activity/checkinShare/awardList', {
            moduleId,
            activityId: this.activityId
        }).then((res) => {
            if(res.return_code == 200 || res.code == 200){
                this.awardDisplayList = res.data
            }else{
                this.$toast(res.return_msg || res.message)
            }
        })
    },
    // 获取分享模块信息
    shareInfo() {
        active.shareInfo(config.API_HOST + "/apiserv/api/activity/share/shareInfo", { 
            activityId: this.activityId,
            moduleId: this.shareModuleId,
            uuid: this.uuid
        }).then((res) => {
            if (res.return_code != 200) {
                this.$toast(res.return_msg);
                return;
            }
            // 1-微信，2-朋友圈，3-QQ，4-QQ空间
            res.data.activityContentShare.btnArr = res.data.activityContentShare.btn.split(';');
            this.shareData = res.data.activityContentShare;
            // this.awardCount = res.data.awardCount;
            // this.shareCount = res.data.shareCount;
            // this.uiTitle = res.data.uiTitle;
        }).catch((error) => {
            this.$toast('网络不稳定，请稍后');
        });
    },
    // 获取分享域名
    getShareCsvByLocationId() {
        active.shareInfo(config.API_HOST + "/apiserv/api/share/getShareCsvByLocationId", { 
            locationId: 202 // 定制活动:202,活动模板:201
        }).then((res) => {
            if (res.return_code != 200) {
                this.$toast(res.return_msg);
                return;
            }
            this.shareUrlArr = res.data;
        }).catch((error) => {
            this.$toast('网络不稳定，请稍后');
        });
    },
    // 分享
    shareWeb(shareType) {
        if (!this.correctTerminal()) { // 判断运行环境是否是233
            return false;
        }
        this.$tea('event_activemodal_share', { 'activityId': this.activityId, 'modelId':this.shareModuleId});//数据埋点
        let shareStyle;
        let teaShareType; // 埋点分享类型
        let url;
        let shareUrl;
        switch(shareType) {
            case 0x1:
                shareStyle = 0x15;
                teaShareType = 1;
                this.shareUrlArr.map(item => {
                    if (item.shareApp == "1") { // shareApp = 1微信、2朋友圈、3QQ、4QQ空间
                        shareUrl = item.domain.domain;
                    }
                });
                break;
            case 0x2:
                shareStyle = 0x16;
                teaShareType = 2;
                this.shareUrlArr.map(item => {
                    if (item.shareApp == "2") {
                        shareUrl = item.domain.domain;
                    }
                });
                break;
            case 0x3:
                shareStyle = 0x1f;
                teaShareType = 3;
                this.shareUrlArr.map(item => {
                    if (item.shareApp == "3") {
                        shareUrl = item.domain.domain;
                    }
                });
                break;
            case 0x4:
                shareStyle = 0x20;
                teaShareType = 4;
                this.shareUrlArr.map(item => {
                    if (item.shareApp == "4") {
                        shareUrl = item.domain.domain;
                    }
                });
                break;
        }
        const env = window._API_HOST().NODE_ENV
        const shareBaseHost = window._API_HOST().shareBaseHost
        if (env === "production") { // 正式服
            url = shareUrl;
        } else { // 测试，预发
            url = shareBaseHost;
        }
        let shareInfo = {
            // 分享网页4个参数
            targetUrl: url + 'main?id=' + this.activityId + '&u=' + this.uuid + '&f=201' + '&g=4' + '&c=' + this.activityId, // 分享链接 f-分享功能ID,g-分享关系,c-分享关系参数,u-分享人的UUID
            title: this.shareData.title, // 分享标题
            desc: this.shareData.shareDescribe, // 分享描述
            imgUrl: this.shareData.icon, // 分享图标
            // web
            shareType: shareType, // Int 微信 0x1，微信朋友圈 0x2，QQ 0x3，QQ空间 0x4
            shareStyle: shareStyle, // 落地分享展现方式, 只分享文字 0xB,微信网页 0x15,微信朋友圈分享网页 0x16,qq分享网页 0x1f,qq空间分享网页 0x20
            isWeb: true, // 是否由web端创建对话框
            locationId: 202, //Int 功能ID
            relationship: 4, //Int 关系（3:游戏分享）
            relationshipExtra: this.activityId, //Long关系参数（3：gameId） string
            pos: 2001, //Int APP进入位置
            posExtra: this.activityId //Long APP进入位置参数
        };
        this.$tea("event_new_share_click", {activityId: this.activityId, modul: 10301, locationId: 201, relationship: 4, relationshipExtra2: this.activityId, pos: 2001, shareType: teaShareType, guide: this.guide ? this.guide : false});
        if (primaryApi.share(shareInfo)) {// 调用安卓api分享
            // 默认唤起Android分享成功即分享成功
            this.setShareCheckInDay()
            this.shareSignal();
        }
    },
    // 通知服务端分享成功
    shareSignal() {
        active.shareSignal(config.API_HOST + "/apiserv/api/activity/share/shareSignal", { 
            activityId: this.activityId,
            moduleId: this.shareModuleId,
            uuid: this.uuid
        }).then((res) => {
            if (res.return_code != 200) {
                this.$toast(res.return_msg);
                return;
            }
        }).catch((error) => {
            this.$toast('网络不稳定，请稍后');
        });
    },
    // 判断活动状态
    lock() {
        if (this.activityStatus == 0) {
            //活动展示期
            this.$toast('【' + this.entryObj.activityServer.startTime + '】开启活动');
            return false;
        } else if (this.activityStatus == 1) {
            this.disabled = false;
            return true;
        } else if (this.activityStatus == 2) {
            this.$toast('活动已结束，请等待下次活动');
            return false;
        } else {
            this.$toast('活动已结束，请等待下次活动');
            return false;
        }
    },
    // 获取游戏主推信息
    getGame(gameModuleId) {
        active.getGame(config.API_HOST + "/apiserv/api/activity/game/getGame", { 
            activityId : this.activityId,
            moduleId:gameModuleId,
            uuid: this.uuid
        }).then((res) => {
            if (res.return_code != 200) {
                this.$toast(res.return_msg);
                return;
            }
            this.gameId = res.data.activityContentGame.gameId;
            // this.bookingInfo = res.data.activityContentGame.bookingInfo;
            // this.bookingCompleteInfo = res.data.activityContentGame.bookingCompleteInfo;
            this.getGamesByIds(res.data);
        }).catch((error) => {
            this.$toast('网络不稳定，请稍后');
        });
    },
    // 根据gameId获取游戏信息
    getGamesByIds(data) {
        active.getGamesByIds(config.API_HOST + "/apiserv/api/repository/game/getGamesByIds", qs.stringify({
            ids: this.gameId
        })).then((res) => {
            if (res.return_code != 200) {
                this.$toast(res.return_msg);
                return;
            }
            let dataObj = JSON.parse(JSON.stringify(data));
            dataObj.detail = res.data[0].detail;
            this.gameInf = dataObj;
            this.processInf();
        }).catch((error) => {
            this.$toast('网络不稳定，请稍后');
        });
    },
    // 处理模块信息显示
    processInf () {
        if (this.gameInf.activeState == 'HIDE') { // 游戏下线
            this.btnTxt = '查看游戏';
        } else if (this.gameInf.activeState == 'SUBSCRIBED') { // 游戏处于预约状态
            if (this.gameInf.bookingState) { // 用户是否预约
                this.btnTxt = '已预约';
            } else {
                this.btnTxt = this.gameInf.activityContentGame.bookingText;
            }
        } else if (this.gameInf.activeState == 'OPEN') { // 游戏上线
            if (!primaryApi.isSource) { // 判断运行环境是否是233，非233时逻辑只要到这里即可，否则调用android方法会报错
                this.btnTxt = '查看游戏';
                return false;
            }
            if (this.gameInf.detail.installEnvStatus == 'VIRTUAL') { //233内部
                if (primaryApi.isGameInstall(this.gameInf.detail.packageName)) { //内部是否安装了此游戏
                    this.btnTxt = this.gameInf.activityContentGame.installText;
                } else {
                    this.btnTxt = this.gameInf.activityContentGame.downloadText;
                }
            } else if(this.gameInf.detail.installEnvStatus == 'ANDROID_SYSTEM') { //安卓外部
                if (primaryApi.isInstallOuterApp(this.gameInf.detail.packageName)) { //外部是否安装了此游戏
                    this.btnTxt = this.gameInf.activityContentGame.installText;
                } else {
                    this.btnTxt = this.gameInf.activityContentGame.downloadText;
                }
            }
        }
    },
    // 游戏上线，安装游戏和预约
    clickBtn() {
        if (!this.correctTerminal()) { // 判断运行环境是否是233
            return false;
        }
        this.maskType = false
        if (this.isDownload) { // 处于下载游戏过程
            if (this.status == 1 || this.status == 3) {
                this.$tea("event_active_game_click", {activityId: this.activityId, modul: 10601, btnstatus: 13, guide: this.guide ? this.guide : false}); // 数据埋点
                primaryApi.downloadGame(this.gameInf.detail, this.progress) //继续下载游戏
                this.status = null; //初始状态
                this.isDownload = true;
            } else { //暂停
                this.$tea("event_active_game_click", {activityId: this.activityId, modul: 10601, btnstatus: 12, guide: this.guide ? this.guide : false}); // 数据埋点
                this.isDownload = true;
                primaryApi.downloadStop(this.gameInf.detail);
            }
        } else {
            if (this.gameInf.activeState == 'HIDE') { // 游戏下线
                this.goGameDetail();
            } else if (this.gameInf.activeState == 'SUBSCRIBED') { // 游戏处于预约状态
                if (!this.gameInf.bookingState) { // 用户是否预约
                    this.showBooking();
                }
            } else if (this.gameInf.activeState == 'OPEN') { // 游戏上线
                if (this.gameInf.detail.installEnvStatus == 'VIRTUAL') { //233内部
                    if (primaryApi.isGameInstall(this.gameInf.detail.packageName)) { //内部是否安装了此游戏
                        this.$tea("event_active_game_click", {activityId: this.activityId, modul: 10601, btnstatus: 3, guide: this.guide ? this.guide : false}); // 数据埋点
                        primaryApi.playGame(this.gameInf.detail); //唤起内部游戏
                    } else {
                        this.$tea("event_active_game_click", {activityId: this.activityId, modul: 10601, btnstatus: 11, guide: this.guide ? this.guide : false}); // 数据埋点
                        primaryApi.downloadGame(this.gameInf.detail, this.progress); //下载并安装游戏
                    }
                } else if (this.gameInf.detail.installEnvStatus == 'ANDROID_SYSTEM') { //安卓外部
                    if (primaryApi.isInstallOuterApp(this.gameInf.detail.packageName)) { //外部是否安装了此游戏
                        this.$tea("event_active_game_click", {activityId: this.activityId, modul: 10601, btnstatus: 3, guide: this.guide ? this.guide : false}); // 数据埋点
                        primaryApi.openOuterAppByPackage(this.gameInf.detail.packageName); //唤起外部游戏
                    } else {
                        this.$tea("event_active_game_click", {activityId: this.activityId, modul: 10601, btnstatus: 11, guide: this.guide ? this.guide : false}); // 数据埋点
                        primaryApi.downloadGame(this.gameInf.detail, this.progress); //下载并安装游戏
                    }
                }
            }
        }
    },
    // 跳转到游戏详情
    goGameDetail() {
        if (!this.correctTerminal()) { // 判断运行环境是否是233
            return false;
        }
        window.location.href = 'metaapp://233xyx/detail/game?key_game_id=' + this.gameId;
        this.$tea("event_active_game_click", {activityId: this.activityId, modul: 10601, btnstatus: 1, guide: this.guide ? this.guide : false}); // 数据埋点
    },
    // 预约
    showBooking() {
        this.$tea("event_active_game_click", {activityId: this.activityId, modul: 10601, btnstatus: 2, guide: this.guide ? this.guide : false}); // 数据埋点
    },
    /* 233乐园内/外部下载进度的回调 */
    downloadProgress(pkg, progress) {
        if (pkg == this.gameInf.detail.packageName) {
            this.progress = progress;
            const num = this.progress * 100;
            this.speed = num.toFixed(2) + '%';
            this.btnTxt = this.speed;
            this.isDownload = true;
        }
    },
    /* 233乐园内/外部下载失败回调 */
    downloadFailed(pkg) {
        if (pkg == this.gameInf.detail.packageName) {
            this.status = 3;
            this.btnTxt = '下载失败';
        }
    },
    /* 233乐园内/外部下载暂停回调 */
    downloadInterrupt(pkg) {
        if (pkg == this.gameInf.detail.packageName) {
            this.status = 1;
            this.btnTxt = '继续下载';
        }
    },
    /* 233乐园内/外部下载成功回调 */
    downloadSuccess(pkg) {
        if (pkg == this.gameInf.detail.packageName) {
            this.status = 2;
            this.isDownload = false;
            this.btnTxt = this.gameInf.activityContentGame.installText;
        }
    }
  }
}
</script>

<style scoped>
    .ellipsis{
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .signIn-container{
        width:100%;
        background:#F5B06D;
    }
    .banner{
        width:100%;
        height:4.44rem;
        position:relative
    }
    .banner img{
        width:100%
    }
    .award-module{
        width:100%;
        position: relative;
        background-position: top 0.1rem center;
        background-repeat: no-repeat;
        background-size:100% 1.5rem;
        padding-bottom: 0.16rem;
    }
    .bg-title{
        margin:0.08rem auto 0 auto;
        width:1.525rem;
        height:0.47rem;
        display:block;
    }
    .borderShadow{
        width:3.55rem;
        border-radius:0.08rem;
        border:solid 0.02rem #714327;
        margin:0 auto;
        background:#A4774E;
        padding:0.09rem 0.07rem;
        box-shadow: 0px 0 0px 0px #CCA178, 0px 0px 0px 0px #CCA178,0 0.06rem 1px -2px #B8713F,inset 0px 2px 0px 0px #CCA178;
        margin-top:-2px;
    }
    .award-frame{
        width: 3.41rem;
        height: 1.68rem;
        background: #FFF7E2;
        border: 0.02rem solid #714327;
        border-radius: 0.08rem;
        box-shadow: inset 0px 3px 0px 0px #AB8B5E,inset 0px -3px 0px 0px #AB8B5E,inset 3px 0px 0px 0px #AB8B5E,inset -3px -1px 0px 0px #AB8B5E;
        display:flex;
        justify-content: space-around;
        align-items: center;
    }
    .award-frame .award-row{
        width:0.9rem;
        height:1.18rem;
        background-position: center center;
        background-repeat: no-repeat;
        background-size:100% 100%;
    }
    .award-frame .award-row img{
        width:0.6rem;
        height:0.6rem;
        margin: 0.12rem auto 0.16rem auto;
        display:block;
        border-radius:0.06rem;
    }
    .award-frame .award-name{
        width:0.78rem;
        height:0.19rem;
        line-height:0.19rem;
        font-size:0.12rem;
        color:#89551E;
        text-align:center;
        margin:0.06rem auto 0 auto;
        padding:0 0.04rem;
    }
    .share-award-module{
        width:100%;
        /* height:5.5rem; */
        position: relative;
        background-position: top 0.1rem center;
        background-repeat: no-repeat;
        background-size:100% 0.33rem;
        padding-bottom:16px;
    }
    .share-frame{
        width: 3.41rem;
        height: 4.46rem;
        background: #FFF7E2;
        border: 0.02rem solid #714327;
        border-radius: 0.08rem;
        box-shadow: inset 0px 3px 0px 0px #AB8B5E,inset 0px -3px 0px 0px #AB8B5E,inset 3px 0px 0px 0px #AB8B5E,inset -3px -1px 0px 0px #AB8B5E;
        padding:0 0.12rem
    }
    .award-column{
        width:100%;
        height:1.58rem;
        display:flex;
        justify-content: space-around;
        align-items: center;
    }
    .share-frame .award-row{
        width:0.9rem;
        height:1.42rem;
        background-position: top center;
        background-repeat: no-repeat;
        background-size:100% 1.1rem;
        position:relative
    }
    .share-frame .award-row-img{
        width:0.6rem;
        height:0.6rem;
        margin: 0.12rem auto 0.12rem auto;
        display:block;
        border-radius:6px;
    }
    .share-frame .award-name{
        width:0.78rem;
        height:0.19rem;
        line-height:0.19rem;
        font-size:0.12rem;
        color:#89551E;
        text-align:center;
        margin: 0 auto;
        padding:0 0.04rem;
    }
    .title-tip{
        font-size: 0.15rem;
        font-family: PingFang SC;
        font-weight: bold;
        color: #774733;
        line-height: 0.5rem;
        text-align:center
    }
    .bg-award-text{
        position:absolute;
        left:0;
        bottom:0.01rem;
        width:0.9rem;
        height:0.32rem;
        line-height:0.27rem;
        background-position: center center;
        background-repeat: no-repeat;
        background-size:100% 100%;
        text-align:center;
        color:#946842;
        font-size:0.12rem;
        font-weight:bold;
    }
    .bg-award-text span{
        font-weight:bold;
        color:#882D00;
        font-size:0.15rem
    }
    .btn{
        width:1.27rem;
        height:0.52rem;
        margin: 0 auto;
        background-position: center center;
        background-repeat: no-repeat;
        background-size:100% 100%;
        color:white;
        font-weight:bold;
        text-align:center;
        line-height:0.48rem;
    }
    .btn span{
        width:200%;
        font-size:0.32rem;
        transform:scale(0.5) translateX(-50%);
        display:block;
        letter-spacing:0.03rem
    }
    .signIn-module{
        width:100%;
        position: relative;
        background-position: top 0.1rem center;
        background-repeat: no-repeat;
        background-size:100% 0.4rem;
        padding-bottom:16px;
    }
    .signIn-frame{
        width: 3.41rem;
        background: #FFF7E2;
        border: 0.02rem solid #714327;
        border-radius: 0.08rem;
        box-shadow: inset 0px 3px 0px 0px #AB8B5E,inset 0px -3px 0px 0px #AB8B5E,inset 3px 0px 0px 0px #AB8B5E,inset -3px -1px 0px 0px #AB8B5E;
        padding:0 0.12rem;
        padding:0.2rem 0.08rem 0.14rem 0.08rem;
    }
    .signIn-info{
        width: 3.15rem;
        height: 0.39rem;
        background: #DDBB99;
        border: 1px solid #7B4F28;
        border-radius: 0.04rem;
        margin:0.09rem auto 0 auto;
        line-height:0.38rem;
        color:#774733;
        font-size:0.14rem;
        padding:0 0.1rem 0 0.1rem;
        box-shadow: inset 0px 2px 0px 0px #C7AD92,inset 0px -2px 0px 0px #C7AD92,inset 2px 0px 0px 0px #C7AD92,inset -2px -1px 0px 0px #C7AD92;
        background:#ECD4BA;
        font-weight:500
    }
    .signIn-info span{
        float:right
    }
    .signIn-info b{
        color:#E75320;
        font-weight:400;
    }
    .signIn-list{
        display:flex;
        flex-wrap:wrap;
        justify-content: flex-start;
    }
    .signIn-row{
        margin:0.14rem 0.06rem 0 0.06rem;
        width:0.68rem;
        height:0.83rem;
        align-content:flex-start;
        background-position: center center;
        background-repeat: no-repeat;
        background-size:100% 100%;
        font-size:0;
        position: relative;
    }
    .award-mask{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.6);
        border-radius: 0.08rem;
    }
    .share-award-mask{
        position: absolute;
        top: 0.06rem;
        left: 50%;
        width: 0.78rem;
        height: 0.74rem;
        background: rgba(0,0,0,0.6);
        border-radius: 0.06rem;
        transform: translateX(-50%);
    }
    .icon-geted{
        top: 48%;
        left: 50%;
        width: 0.4rem;
        height: 0.33rem;
        position: absolute;
        transform: translate(-50%,-50%);
    }
    .signIn-award-title{
        text-align:center;
        color:white;
        font-size:0.2rem;
        transform:scale(0.5) translate(-50%,-46%);
        width:200%;
        line-height:0.36rem;
        height:0.36rem;
    }
    .signIn-award-title span{
        font-size:0.24rem;
        padding: 0 0.04rem 0 0.02rem
    }
    .signIn-row-img{
        display:block;
        width:0.3rem;
        height:0.3rem;
        margin: -0.12rem auto 0.06rem auto;
    }
    .signIn-award-name{
        color:#89551E;
        font-size:0.16rem;
        transform:scale(0.5) translate(-50%,-50%);
        text-align:center;
        width:200%;
        line-height:0.42rem;
        letter-spacing:0.1em;
        font-weight:500;
    }
    .share-module{
        width:100%;
        height:1.66rem;
        background-position: top 0.1rem center;
        background-repeat: no-repeat;
        background-size:100% 0.32rem;
        padding-top:0.24rem;
        display:flex;
        justify-content:space-around;
    }
    .share-row{
        width:0.84rem;
        height:1.13rem;
        background-position: top center;
        background-repeat: no-repeat;
        background-size:100% 0.83rem;
    }
    .share-row img{
        width:0.46rem;
        height:0.46rem;
        margin:0.16rem 0 0.26rem 0.2rem;
        display:block
    }
    .share-row-name{
        text-align:center;
        font-size:0.12rem;
        color:#89551E;
        width:0.8rem;
        height:0.22rem;
        line-height:0.2rem;
        background: #EFD5B1;
        border: 1px solid #6B3916;
        border-radius: 6px;
        margin:0 auto;
        font-weight:500;
    }
    .banner-btn{
        position:absolute;
        bottom:0.23rem;
        width:1.73rem;
        height:0.68rem;
        background-position: center center;
        background-repeat: no-repeat;
        background-size:100% 100%;
        text-align:center;
        line-height:0.60rem;
        left:1.01rem;
        color:white;
        /* text-shadow: #6B3916 1px 0 0, #6B3916 0 1px 0, #6B3916 -1px 0 0, #6B3916 0 -1px 0; */
    }
    .banner-btn span{
        font-size:0.33rem;
        width:125%;
        transform:scale(0.8) translateX(-12.5%);
        display:block;
        letter-spacing:0.03rem;
        font-weight:bolder;

    }
    .btn:active{
        transform:scale(0.9);
    }
    .banner-btn:active{
        transform:scale(0.9);
    }
    .status-bar{
        width:100%;
        height:0.38rem;
        line-height:0.38rem;
        color:white;
        font-size:0.12rem;
        padding:0 0.2rem;
        position:absolute;
        top:0;
        left:0;
        background:rgba(102,104,105,0.6);
        z-index:10
    }
    .status-bar span{
        display:block;
        position:absolute;
        right:0.2rem;
        top:0.07rem;
        background:rgba(82,99,101,0.8);
        width:0.6rem;
        height:0.24rem;
        border-radius:0.06rem;
        line-height:0.24rem;
        padding:0 0.2rem 0 0.15rem
    }
    .status-bar span label{
        width:0.05rem;
        height:0.05rem;
        border-top:solid 1px white;
        border-right: solid 1px white;
        transform:rotate(45deg) translateY(-50%);
        display:block;
        position:absolute;
        right:0.15rem;
        top:50%;
    }
</style>
